export const INROUTES  = {
    HOME: "/",
    FINDMYDEVICE: "/FindMyDevice",
    FINDMYDEVICE_SCAN: "/FindMyDevice/scan",

    SKYTONE: "/skytone",
    SKYTONE_HOME: "/skytone",
    SKYTONE_ABOUT: "/skytone/About",
    SKYTONE_MODULE: "/skytone/Module",
    SKYTONE_FRAME: "/skytone/Frame",
    SKYTONE_WIFI: "/skytone/Wifi",
    SKYTONE_SETTING: "/skytone/Setting",
    SKYTONE_FAQ: "/skytone/Faq",
};

export const EXTERNAL_LINKS = {
    SMARTSTORE: "https://smartstore.naver.com/dafthings",
    ZCARD: "https://zcard.kr/dafthings",
    KAKAOCH: "https://pf.kakao.com/_npnPG/chat",
    INSTAGRAM: "https://www.instagram.com/dafthings",
    BUYSKYTONE: "https://smartstore.naver.com/dafthings",
};